import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import classnames from "classnames";
import colors from "/styles/colors";
import { componentStyles } from "./layout-option-component.scss";
class LayoutOptionComponent extends PureComponent {
    onSelect() {
        const { selectCallback, option } = this.props;
        selectCallback(option.id);
    }
    render() {
        const { selected, singleImage, option } = this.props;
        const image = singleImage && option.detailsImage ? option.detailsImage : option.image;
        const text = singleImage && option.detailsText ? option.detailsText : option.text;
        const style = {
            backgroundColor: colors[option.backgroundColor]
        };
        return /*#__PURE__*/ _jsxs("div", {
            onMouseDown: this.onSelect,
            style: style,
            className: `jsx-${componentStyles.__hash}` + " " + (classnames("manage-option", {
                selected: selected,
                "big-image": singleImage
            }) || ""),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "text-wrapper",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: `jsx-${componentStyles.__hash}` + " " + (classnames("option-text", {
                            "is-other": option.detailsText
                        }) || ""),
                        children: [
                            " ",
                            text
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "image-wrapper",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: image,
                        className: `jsx-${componentStyles.__hash}` + " " + "option-image"
                    })
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.onSelect = this.onSelect.bind(this);
    }
}
export { LayoutOptionComponent as default };
